// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"77":"b66a48a2","93":"c19b0bba","204":"96c5404d","274":"48c9d83f","479":"4a01b3e3"}[chunkId] + ".chunk.js";
};